import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './advertis.css';
import bgImage1 from './../images/rec1.jpg';
import bgImage2 from './../images/rec2.jpg';
import bgImage3 from './../images/rec3.jpg';

function Advertis() {
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = () => {
    if (selectedFile) {
      console.log('File to upload:', selectedFile);
      alert(`File uploaded: ${selectedFile.name}`);
      // Implement your file upload logic here
    } else {
      alert('No file selected');
    }
  };

  return (
    <>
      <button className="wrap-validate_item main-menu-btn-histor" onClick={() => navigate('/dashboard')}>Main Menu</button>
      <div className="adverstis">
        <div className="adverstis__item">
          <div className="adverstis__item_wrap">
            <div className="adverstis__item_text">advertis</div>
          </div>
          <div className="adverstis__item_wrapW">
            <div className="adverstis__item_upload">
              <img src={bgImage1} alt="Advertis background" />
            </div>
            <div className="adverstis__item_button">
                <div >
                  <h2>Upload a File</h2>
                  <input
                    type="file"
                    id="file-upload"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                  <div className="upWrap">
                    <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                      <span className="wrap-da__item1">
                        Choose File
                      </span>
                    </label>
                    <button
                    className="wrap-da__item1"
                      onClick={handleUpload}
                    >
                      Upload
                    </button>
                  </div>
                  {selectedFile && <p>Selected File: {selectedFile.name}</p>}
                </div>
              </div>
          </div>
          
        </div>

        <div className="adverstis__item">
          <div className="adverstis__item_wrap">
            <div className="adverstis__item_text">advertis</div>
          </div>
          <div className="adverstis__item_wrapW">
            <div className="adverstis__item_upload">
              <img src={bgImage2} alt="Advertis background" />
            </div>
            <div className="adverstis__item_button">
                <div >
                  <h2>Upload a File</h2>
                  <input
                    type="file"
                    id="file-upload"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                  <div className="upWrap">
                    <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                      <span className="wrap-da__item1">
                        Choose File
                      </span>
                    </label>
                    <button
                    className="wrap-da__item1"
                      onClick={handleUpload}
                    >
                      Upload
                    </button>
                  </div>
                  {selectedFile && <p>Selected File: {selectedFile.name}</p>}
                </div>
              </div>
          </div>
          
        </div>

        <div className="adverstis__item">
          <div className="adverstis__item_wrap">
            <div className="adverstis__item_text">advertis</div>
          </div>
          <div className="adverstis__item_wrapW">
            <div className="adverstis__item_upload">
              <img src={bgImage3} alt="Advertis background" />
            </div>
            <div className="adverstis__item_button">
                <div >
                  <h2>Upload a File</h2>
                  <input
                    type="file"
                    id="file-upload"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                  <div className="upWrap">
                    <label htmlFor="file-upload" style={{ cursor: 'pointer' }}>
                      <span className="wrap-da__item1">
                        Choose File
                      </span>
                    </label>
                    <button
                    className="wrap-da__item1"
                      onClick={handleUpload}
                    >
                      Upload
                    </button>
                  </div>
                  {selectedFile && <p>Selected File: {selectedFile.name}</p>}
                </div>
              </div>
          </div>
          
        </div>
      </div>
    </>
  );
}

export default Advertis;